import {NumericFormat} from 'react-number-format'
import styled, {css} from 'styled-components'
import {makeInputBaseStyle} from '../input-text/style'

export const StyledInputPrice: typeof NumericFormat = styled(NumericFormat)`
    ${({theme}) => css`
        ${makeInputBaseStyle(theme)}
    `}
`
